// Lib
import React from 'react';

// Components
import { ReactComponent as Grid } from '../../../assets/svg/grid.svg';

// Styles
import { useStyles } from './GridButtonStyles';

const GridButton = ({ isActive, className, ...props }) => {
  const { classes, cx } = useStyles();

  return (
    <Grid
      id="grid-button"
      className={cx(classes.root, isActive && classes.active, className)}
      {...props}
    />
  );
};

export default GridButton;
